<template>
  <div>
    <!-- 一级路由出口 -->
    <router-view></router-view>
    <audio id="alarmBgm" :src="$static_URL + 'static/alarm.mp3'" loop></audio>
  </div>
</template>

<script>
import { Loading } from "element-ui";
export default {
  data() {
    return {
      loadingInstance: null,
    };
  },
  methods: {},
  mounted() {
    window.audio = document.getElementById("alarmBgm");
    document.onclick = () => {
      audio.pause();
    };
    window.addEventListener("offline", () => {
      this.loadingInstance = Loading.service({
        fullscreen: true,
        background: "rgba(0, 0, 0, 0.8)",
      });
    });
    window.addEventListener("online", () => {
      this.loadingInstance.close();
    });
  },
};
</script>

<style scoped>
</style>
